import { render, staticRenderFns } from "./SwitchField.vue?vue&type=template&id=6c5e3bc8"
import script from "./SwitchField.vue?vue&type=script&lang=ts"
export * from "./SwitchField.vue?vue&type=script&lang=ts"
import style0 from "./SwitchField.vue?vue&type=style&index=0&id=6c5e3bc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports